import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import CashFlowUI from '../../../components/superUser/transaction/CashFlowUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import CFCreateModalSF from '../../../components/superUser/transaction/CFCreateModalSF'
import './CashFlowPage.css'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF.js'

const CashFlowPageUI = ({context, account, cashFlowList, onRefreshClick,
    createMode, onCreateClick, onCancelClick,
    updateMode, onUpdateClick, selectedCashFlow, onDownloadCashFlowTemplate, cashFlowDownloadRequested,
    cashFlowUploadMode, onCashFlowUploadClick, onCashFlowUploadCancel, onCashFlowUpload
  }) =>
  <SuperUserAccountPageUI context={context} className='pg_su_cf' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`} dimension='w1000'
    centered={!account || !cashFlowList} account={account} page='cashFlow2'
  >
    {
      (!account || !cashFlowList || cashFlowDownloadRequested) &&
      <SpinnerComponentUI />
    }
    {
      account && cashFlowList &&
      <CashFlowUI
        context={context}
        account={account}
        createMode={createMode}
        onCreateClick={onCreateClick}
        cashFlowList={cashFlowList}
        onRefreshClick={onRefreshClick}
        onUpdateClick={onUpdateClick}
        updateMode={updateMode}
        selectedCashFlow={selectedCashFlow}
        onDownloadCashFlowTemplate={onDownloadCashFlowTemplate}
        // 
        onCashFlowUploadClick={onCashFlowUploadClick}
      />
    }

    <CFCreateModalSF context={context} account={account} createMode={createMode}
      onCancelClick={onCancelClick} onRefreshClick={onRefreshClick}
      updateMode={updateMode} selectedCashFlow={selectedCashFlow}
    />

    <FileUploadModalSF
        context={context}
        uploadMode={cashFlowUploadMode}
        onCancelClick={onCashFlowUploadCancel}
        signedUrlApi={`/api/su/accounts/${account && account.accountId}/cashFlows/fileUploadSignedUrl`}
        onUpload={onCashFlowUpload}
      />

  </SuperUserAccountPageUI>

export default CashFlowPageUI
